import React, {useContext, useEffect, useState} from 'react'
import { Link, useRouteMatch } from 'react-router-dom'
import crumbContext from "contexts/crumbs"
import "./buttons.scss"
export default function BigButton(props) {
    const {title, icon, page, background, setHeadbandIcon, headbandBackground, routes, url, left, right, top, delay} = props
    const {crumbs, setCrumbs} = useContext(crumbContext)
    const [opacity, setOpacity] = useState(0)
    const [positionLeft, setPositionLeft] = useState(left ? left : 0)
    const [positionRight, setPositionRight] = useState(right ? right : 0)
    const [positionTop, setPositionTop] = useState(top ? top : 0)
    useEffect(() => {
        setOpacity(1)
        setTimeout(() => {
            setPositionRight(0)
            setPositionLeft(0)
            setPositionTop(0)
        }, delay)
    }, [])
    const addCrumb = {
        title : title,
        page : page,
    }

    return (
        <div className={`bigButton ${ background }`} style={{left : left && positionLeft, right : right && positionRight, top : top && positionTop, opacity : opacity}} >
            <Link to={page}
                onClick={() => {
                    setCrumbs(oldCrumbs => [...oldCrumbs, addCrumb])                   
                }} 
                className='btnContainer'
            >
                    <div className='btnTitle h100 flex center'>
                        <h3>
                            {title}
                        </h3> 
                    </div>
                    <img className='btnImg' src={"/" +  icon} alt={icon} style={{opacity : opacity}} />
                    <img className='finger' src="/finger-white.svg" alt="" />
            </Link>
        </div>
    )
}
